export interface DebouncedFunction<T extends unknown[]> {
  (...args: T): void;
  /** Run the pending call immediately, if any. */
  flush: () => void;
  /** Drop the pending call, if any. */
  cancel: () => void;
}

export const debounce = <T extends unknown[]>(func: (...args: T) => void, delay: number): DebouncedFunction<T> => {
  let timeout: ReturnType<typeof setTimeout>;
  let pendingArgs: T | null = null;
  let pendingThis: unknown;

  const debounced = function (this: unknown, ...args: T) {
    pendingArgs = args;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    pendingThis = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      pendingArgs = null;
      func.apply(pendingThis, args);
    }, delay);
  } as DebouncedFunction<T>;

  debounced.flush = () => {
    if (pendingArgs === null) return;
    clearTimeout(timeout);
    const args = pendingArgs;
    pendingArgs = null;
    func.apply(pendingThis, args);
  };

  debounced.cancel = () => {
    clearTimeout(timeout);
    pendingArgs = null;
  };

  return debounced;
};
